/* DISTINCT white - intro
   Schermata bianca. La Dodge SRT fa una sgommata, parte, e dal fumo grigio
   esce piano la scritta Distinct. Poi il sito si apre. */
(function () {
  'use strict';

  var root = document.documentElement;
  var el = document.getElementById('intro');
  if (!el) return;
  if (!root.classList.contains('intro-on')) { el.parentNode.removeChild(el); return; }

  try { sessionStorage.setItem('distinct-intro', '1'); } catch (e) {}

  var car = document.getElementById('introCar');
  var canvas = document.getElementById('introSmoke');
  var ctx = canvas.getContext('2d');
  var rwSpokes = el.querySelector('#rwSpokes');
  var rwBlur = el.querySelector('#rwBlur');
  var fwSpokes = el.querySelector('#fwSpokes');
  var fwBlur = el.querySelector('#fwBlur');

  /* tempi in secondi */
  var T_FADE = 0.4;    // la macchina compare
  var T_BURN = 0.4;    // inizia la sgommata da fermo
  var T_GO = 1.7;      // parte
  var D_EXIT = 1.15;   // tempo per uscire dallo schermo
  var T_WORD = 1.95;   // la scritta comincia a leggersi
  var T_OUT = 4.85;    // l'intro si dissolve
  var SCALE = 0.5;     // il fumo e' morbido: canvas a meta' risoluzione

  var W, H, carW, carH, x0, gY, unit;
  var parts = [];
  var sprites = [];
  var acc = 0;
  var angR = 0, angF = 0;
  var prevCx = 0;
  var t0 = null, last = 0, raf = 0, done = false, revealed = false, out = false;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function rand(a, b) { return a + Math.random() * (b - a); }
  function smooth(x) { x = clamp(x, 0, 1); return x * x * (3 - 2 * x); }

  function layout() {
    W = window.innerWidth;
    H = window.innerHeight;
    canvas.width = Math.round(W * SCALE);
    canvas.height = Math.round(H * SCALE);
    carW = Math.min(W * 0.86, 780);
    carH = carW * 300 / 850;
    unit = carW / 780;
    x0 = W * 0.47 - carW / 2;
    gY = H * 0.7;
    car.style.width = carW + 'px';
    car.style.top = (gY - carH * 280 / 300) + 'px';
    car.style.transformOrigin = (carW * 215 / 850) + 'px ' + (carH * 280 / 300) + 'px';
  }

  /* fumo: sprite a nuvola, grigio sul bianco */
  function makeSprite(seed) {
    var s = 192, c = document.createElement('canvas');
    c.width = c.height = s;
    var g = c.getContext('2d');
    var r = seed * 9301 + 49297;
    function rnd() { r = (r * 9301 + 49297) % 233280; return r / 233280; }
    function blob(x, y, rad, a, tone) {
      var gr = g.createRadialGradient(x, y, 0, x, y, rad);
      gr.addColorStop(0, 'rgba(' + tone + ',' + tone + ',' + (tone + 6) + ',' + a + ')');
      gr.addColorStop(0.6, 'rgba(' + tone + ',' + tone + ',' + (tone + 6) + ',' + (a * 0.45) + ')');
      gr.addColorStop(1, 'rgba(' + tone + ',' + tone + ',' + (tone + 6) + ',0)');
      g.fillStyle = gr;
      g.beginPath(); g.arc(x, y, rad, 0, 6.2832); g.fill();
    }
    for (var i = 0; i < 30; i++) {
      var a = rnd() * 6.2832, d = Math.sqrt(rnd()) * 58;
      blob(96 + Math.cos(a) * d, 96 + Math.sin(a) * d, 20 + rnd() * 28, 0.16 + rnd() * 0.2, 118 + ((rnd() * 40) | 0));
    }
    g.globalCompositeOperation = 'destination-in';
    var m = g.createRadialGradient(96, 96, 0, 96, 96, 96);
    m.addColorStop(0, 'rgba(0,0,0,1)');
    m.addColorStop(0.55, 'rgba(0,0,0,.85)');
    m.addColorStop(1, 'rgba(0,0,0,0)');
    g.fillStyle = m; g.fillRect(0, 0, s, s);
    return c;
  }
  for (var k = 1; k <= 4; k++) sprites.push(makeSprite(k * 7));

  function spawn(cx, cy, launch, vel) {
    if (parts.length > 640) return;
    parts.push({
      x: cx + rand(-30, 16) * unit,
      y: cy - rand(0, 12) * unit,
      vx: (launch ? rand(-340, -60) : rand(-260, -20)) * unit - vel * 0.02,
      vy: rand(-290, -70) * unit,
      s0: rand(26, 50) * unit,
      gr: rand(130, 300) * unit,
      life: rand(2.2, 3.6),
      age: 0,
      rot: rand(0, 6.28),
      vr: rand(-0.6, 0.6),
      wa: rand(20, 70) * unit,
      wf: rand(1.2, 2.8),
      wp: rand(0, 6.28),
      sp: (Math.random() * sprites.length) | 0,
      a: rand(0.3, 0.56)
    });
  }

  function setWheel(spokes, blur, ang, perFrame, cx) {
    var b = clamp((perFrame - 22) / 40, 0, 1);
    spokes.setAttribute('transform', 'rotate(' + ang.toFixed(1) + ' ' + cx + ' 226)');
    spokes.style.opacity = (1 - b).toFixed(2);
    blur.style.opacity = b.toFixed(2);
  }

  function frame(now) {
    if (done) return;
    if (t0 === null) { t0 = now; last = now; prevCx = x0 + carW * 215 / 850; }
    var t = (now - t0) / 1000;
    var dt = Math.min(0.05, (now - last) / 1000);
    last = now;

    /* --- macchina --- */
    var x = x0, y = 0, pitch = 0, vel = 0, rwW = 0, fwW = 0, u = 0;
    car.style.opacity = clamp(t / T_FADE, 0, 1);

    if (t < T_GO) {
      var b = clamp((t - T_BURN) / 0.9, 0, 1);
      x = x0 + Math.sin(t * 38) * 0.9 * b;
      y = (Math.sin(t * 71) * 1.1 + Math.sin(t * 23) * 0.7) * b;
      pitch = -0.25 * b + Math.sin(t * 29) * 0.16 * b;
      rwW = (26 + 22 * b) * 6.283;
      fwW = 0;
    } else {
      u = (t - T_GO) / D_EXIT;
      var dist = W - x0 + 60;
      var uu = clamp(u, 0, 1.6);
      x = x0 + dist * Math.pow(uu, 2.3);
      vel = dist * 2.3 * Math.pow(uu, 1.3) / D_EXIT;
      pitch = -2.3 * Math.sin(clamp((t - T_GO) / 0.55, 0, 1) * 1.5708) * (1 - 0.45 * clamp(u, 0, 1));
      rwW = Math.max(vel / 54 * 1.4, 44 * 6.283 * (1 - clamp(u, 0, 1) * 0.7));
      fwW = vel / 54;
      y = Math.sin(t * 60) * 0.6;
    }
    car.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(2) + 'px,0) rotate(' + pitch.toFixed(2) + 'deg)';
    if (x > W + 40) car.style.opacity = 0;

    angR += rwW * dt * 57.2958;
    angF += fwW * dt * 57.2958;
    setWheel(rwSpokes, rwBlur, angR % 360, rwW * dt * 57.2958, 215);
    setWheel(fwSpokes, fwBlur, angF % 360, fwW * dt * 57.2958, 668);

    /* --- fumo: nasce dal punto di contatto della ruota posteriore --- */
    var rate = 0;
    if (t >= T_BURN && t < T_GO) rate = 30 + 210 * clamp((t - T_BURN) / 1.0, 0, 1);
    else if (t >= T_GO && u < 1.05) rate = 250;
    acc += rate * dt;
    var cx = x + carW * 215 / 850;
        var cnt = 0, total = Math.floor(acc);
    while (acc >= 1) {
      acc -= 1; cnt++;
      var f = total > 0 ? cnt / total : 1;
      spawn(prevCx + (cx - prevCx) * f, gY, t >= T_GO, vel);
    }
    prevCx = cx;

    var gm = 1 - smooth((t - 3.0) / 1.7) * 0.94;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (var i = parts.length - 1; i >= 0; i--) {
      var p = parts[i];
      p.age += dt;
      if (p.age >= p.life) { parts.splice(i, 1); continue; }
      p.x += p.vx * dt + Math.sin(p.age * p.wf + p.wp) * p.wa * dt;
      p.y += p.vy * dt;
      p.vx *= 1 - 1.1 * dt;
      p.vy = p.vy * (1 - 1.1 * dt) - 34 * unit * dt;
      p.rot += p.vr * dt;
      var kk = p.age / p.life;
      var s = p.s0 + p.gr * p.age * (1 - 0.35 * kk);
      var al = p.a * Math.min(1, p.age / 0.18) * Math.pow(1 - kk, 1.4) * gm;
      if (al < 0.01) continue;
      var c = Math.cos(p.rot) * SCALE, sn = Math.sin(p.rot) * SCALE;
      ctx.globalAlpha = al;
      ctx.setTransform(c, sn, -sn, c, p.x * SCALE, p.y * SCALE);
      ctx.drawImage(sprites[p.sp], -s / 2, -s / 2, s, s);
    }
    ctx.globalAlpha = 1;

    /* --- scritta e uscita --- */
    if (!revealed && t >= T_WORD) { revealed = true; el.classList.add('is-reveal'); }
    if (!out && t >= T_OUT) { out = true; finish(false); return; }

    raf = requestAnimationFrame(frame);
  }

  function finish(fast) {
    if (done && !out) return;
    done = true;
    cancelAnimationFrame(raf);

    /* la scritta dell'intro vola al posto di quella che gira nella home */
    var word = el.querySelector('.intro__word');
    var hero = document.querySelector('.spin__img');
    el.classList.add('is-final');
    if (word && hero && word.animate) {
      var a = word.getBoundingClientRect();
      var b = hero.getBoundingClientRect();
      var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
      var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
      var sc = b.width / a.width;
      word.animate([
        { transform: 'translate(-50%,-50%)' },
        { transform: 'translate(-50%,-50%) translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px) scale(' + sc.toFixed(4) + ')' }
      ], { duration: fast ? 320 : 780, easing: 'cubic-bezier(.65,0,.25,1)', fill: 'forwards' });
    }
    el.classList.add('is-out');
    setTimeout(function () {
      root.classList.remove('intro-on');
      if (el.parentNode) el.parentNode.removeChild(el);
      document.dispatchEvent(new Event('intro:done'));
    }, fast ? 360 : 820);
  }

  function skip() { if (!done || !out) { out = true; finish(true); } }

  layout();
  window.addEventListener('resize', layout);
  el.addEventListener('click', skip);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('intro-on')) skip(); });

  raf = requestAnimationFrame(frame);
})();
